import { ReportSummaryRow, ClassRow } from './reports-model';

export class InstructorCentricClassItem extends ClassRow {
}

export class InstructorCentricSummary extends ReportSummaryRow {
    classes: InstructorCentricClassItem[];
    constructor(public instructorName: string) {
        super();
        this.classes = [];
        this.totalCost = 0;
        this.totalHours = 0;
    }
}
